import escapeRegExp from 'lodash/escapeRegExp';

import { EMAIL_REGEXP } from '../../../regExp';

const buildOTPEmailPattern = (maskedEmailHint?: string): RegExp => (
    maskedEmailHint
        ? new RegExp(`^(?:${escapeRegExp(maskedEmailHint)}|${EMAIL_REGEXP.source})$`, EMAIL_REGEXP.flags)
        : EMAIL_REGEXP
);

export default buildOTPEmailPattern;
